"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailPillInput = EmailPillInput;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Contacts = require("../../Contacts");

var _RecipientBadge = _interopRequireDefault(require("../../EmailInput/RecipientBadge"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../../utils");

var _utils2 = require("../utils");

var _reactVirtualized = require("react-virtualized");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MIN_INPUT_WIDTH = 20;
var MAX_HEIGHT = 490;

function EmailPillInput(_ref, ref) {
  var _ref$contacts = _ref.contacts,
      contacts = _ref$contacts === void 0 ? [] : _ref$contacts,
      className = _ref.className,
      selectContacts = _ref.selectContacts,
      onSelectChange = _ref.onSelectChange,
      getRecipientAvatar = _ref.getRecipientAvatar,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["contacts", "className", "selectContacts", "onSelectChange", "getRecipientAvatar"]);
  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var contactsRef = (0, _react.useRef)([]);

  var _useState5 = (0, _react.useState)(selectContacts),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      values = _useState6[0],
      setValues = _useState6[1];

  var remainContacts = (0, _react.useMemo)(function () {
    var result = [];

    var _iterator = _createForOfIteratorHelper(contacts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var contact = _step.value;
        var emails = values.map(function (value) {
          return value.email.toLowerCase();
        });

        if (!emails.includes(contact.email.toLowerCase())) {
          result.push(contact);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (!inputValue) return result;
    var matchedContacts = result.filter(function (item) {
      return item.email.toLowerCase().includes(inputValue.toLowerCase()) || item.name.toLowerCase().includes(inputValue.toLowerCase());
    });

    if (!matchedContacts.length && inputValue && (0, _utils.isEmail)(inputValue)) {
      return [{
        name: inputValue.trim(),
        email: inputValue.trim()
      }];
    }

    return matchedContacts;
  }, [values, contacts, inputValue]);
  var autoHeight = (0, _utils2.getAutoHeight)(remainContacts.length, MAX_HEIGHT, 70);

  function renderItem(_ref2) {
    var index = _ref2.index,
        style = _ref2.style,
        key = _ref2.key;
    var contact = remainContacts[index];
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: contact.email,
      onMouseEnter: function onMouseEnter() {
        setSelected(index);
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();

        if (onSelectChange) {
          onSelectChange([].concat((0, _toConsumableArray2["default"])(values), [contact]));
        }

        setValues([].concat((0, _toConsumableArray2["default"])(values), [contact]));
        setInputValue('');
      },
      ref: function ref(node) {
        contactsRef.current[index] = node;
      }
    }, /*#__PURE__*/_react["default"].createElement(_Contacts.Contact, (0, _extends2["default"])({
      highlightWord: inputValue,
      className: (0, _classnames["default"])('px-4', {
        'bg-secondary': selected === index
      }),
      textSzie: "text-lg",
      style: style
    }, contact, {
      avatar: getRecipientAvatar(_objectSpread({}, contact), '!h-12 !w-12')
    })));
  }

  function handleOnKeyDown(e) {
    switch (e.key) {
      case ',':
      case ';':
      case 'ArrowDown':
        {
          e.preventDefault();
          var newSelected = selected + 1 <= remainContacts.length - 1 ? selected + 1 : 0;
          setSelected(newSelected);
          break;
        }

      case 'Enter':
        {
          e.preventDefault();
          var _selectedContact = remainContacts[selected];

          if ((0, _isNil["default"])(_selectedContact) && !(0, _utils.isEmail)(inputValue)) {
            return;
          }

          var _emails = values.map(function (item) {
            return item.email;
          });

          if (_emails.includes(_selectedContact.email)) {
            setValues(values);

            if (onSelectChange) {
              onSelectChange(values);
            }

            setInputValue('');
            return;
          }

          var _nextselectedContacts = (0, _isNil["default"])(_selectedContact) ? [].concat((0, _toConsumableArray2["default"])(values), [{
            name: inputValue.trim(),
            email: inputValue.trim()
          }]) : [].concat((0, _toConsumableArray2["default"])(values), [_selectedContact]);

          setValues(_nextselectedContacts);

          if (onSelectChange) {
            onSelectChange(_nextselectedContacts);
          }

          setInputValue('');
          break;
        }

      case 'ArrowUp':
        {
          e.preventDefault();

          var _newSelected = selected - 1;

          setSelected(_newSelected > -1 ? _newSelected : 0);
          break;
        }

      case 'Backspace':
        {
          e.preventDefault();

          var clearContact = function clearContact() {
            var nextValue = (0, _toConsumableArray2["default"])(values);
            nextValue.pop();
            setValues(nextValue);

            if (onSelectChange) {
              onSelectChange(nextValue);
            }
          };

          if (inputValue.length) {
            var nextValue = inputValue.slice(0, inputValue.length - 1);
            setInputValue(nextValue);
          } else {
            clearContact();
          }

          break;
        }

      case 'Tab':
        e.preventDefault();
        var selectedContact = remainContacts[selected];

        if ((0, _isNil["default"])(selectedContact) && !(0, _utils.isEmail)(inputValue)) {
          return;
        }

        var emails = values.map(function (item) {
          return item.email;
        });

        if (emails.includes(selectedContact.email)) {
          setValues(values);

          if (onSelectChange) {
            onSelectChange(values);
          }

          setInputValue('');
          return;
        }

        var nextselectedContacts = (0, _isNil["default"])(selectedContact) ? [].concat((0, _toConsumableArray2["default"])(values), [{
          name: inputValue.trim(),
          email: inputValue.trim()
        }]) : [].concat((0, _toConsumableArray2["default"])(values), [selectedContact]);
        setValues(nextselectedContacts);

        if (onSelectChange) {
          onSelectChange(nextselectedContacts);
        }

        setInputValue('');
        break;

      default:
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-col text-medium text-sm pt-2",
    style: {
      width: 400
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-end mb-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex px-4 mt-2 flex-wrap items-center w-full -m-1 outline-none"
  }, values.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_RecipientBadge["default"], (0, _extends2["default"])({
      emailCls: "!max-w-xxs",
      className: "relative pl-8"
    }, item, {
      avater: getRecipientAvatar(item, '!w-8 !h-8 absolute left-0'),
      onClose: function onClose() {
        var next = values.filter(function (value) {
          return value.email !== item.email;
        });
        setValues((0, _toConsumableArray2["default"])(next));

        if (onSelectChange) {
          onSelectChange(next);
        }
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
    autoFocus: true,
    ref: inputRef,
    className: (0, _classnames["default"])("m-1 text-dark h-10 pt-2 px-4 bg-transparent text-sm flex-grow pb-2", className),
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: "false",
    value: inputValue,
    onChange: function onChange(e) {
      setInputValue(e.target.value);
    },
    placeholder: "Type a name or email",
    onKeyDown: handleOnKeyDown,
    style: {
      minWidth: MIN_INPUT_WIDTH,
      maxWidth: '100%'
    }
  })))), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.InfiniteLoader, {
    isRowLoaded: function isRowLoaded(index) {
      return !!remainContacts[index];
    },
    loadMoreRows: function loadMoreRows() {
      return null;
    },
    rowCount: remainContacts.length
  }, function (_ref3) {
    var onRowsRendered = _ref3.onRowsRendered,
        registerChild = _ref3.registerChild;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
      ref: function ref(node) {
        registerChild(node);
      },
      height: autoHeight,
      onRowsRendered: onRowsRendered,
      scrollToIndex: selected,
      rowCount: remainContacts.length,
      rowHeight: 70,
      rowRenderer: renderItem,
      overscanRowCount: 5,
      width: 400
    });
  }));
}
//# sourceMappingURL=EmailPillInput.js.map